import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import ImagePicker from "../components/ImagePicker";
import { Button, Alert, Tooltip } from "antd";
import { IoAddCircleOutline } from "react-icons/io5";
import moment from "moment";
import React from "react";
import { FaStarOfLife } from "react-icons/fa6";
function Images(props: any) {
  const imgImp1 = <span>Please choose product cover image</span>;
  const imgImp2 = <span>Please choose at least one image.</span>;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(
    props?.data.length
      ? props?.data
      : [
          {
            id: moment(new Date()).unix(),
            type: "img",
            file: "",
            url: "",
          },
        ]
  );
  const [coverImg, setCoverImg] = useState<any>(props?.coverImg);
  const submit = async () => {
    try {
      props.onChange(data);
      props?.coverImage(coverImg);
    } catch (err) {
      console.log("err", err);
    }
  };

  const CreateNewImage = async () => {
    try {
      setLoading(true);
      let arr = data;
      let obj = {
        id: moment(new Date()).unix(),
        type: "img",
        file: "",
        url: "",
        s3_url: "",
      };
      arr.push(obj);
      setData(arr);
      setTimeout(() => {
        setLoading(false);
      }, 5);
    } catch (err) {
      console.log("CreateNewImage ,err", err);
    }
  };

  const removeNewImage = async (index: number) => {
    try {
      setLoading(true);
      let arr = data;
      arr.splice(index, 1);
      setData(arr);
      setTimeout(() => {
        setLoading(false);
      }, 5);
    } catch (err) {
      console.log("CreateNewImage ,err", err);
    }
  };

  const updateImage = (value: any, index: number) => {
    try {
      setLoading(true);
      let arr = data;
      const item: any = arr[index];
      item["file"] = value.file;
      item["url"] = value.url;
      arr[index] = item;
      setData(arr);
      setTimeout(() => {
        setLoading(false);
      }, 5);
    } catch (err) {
      console.log("updateImage ,err", err);
    }
  };

  return (
    <div>
      <div style={{ minHeight: "64vh" }}>
        <Alert
          message="Follow below guid to reduce quality check failure"
          description={
            <ul>
              <li>
                Products must fill at least 85% of the image. Images must show
                only the product that is for sale, with few or no props
              </li>
              <li>
                Images may only contain text that is a part of the product. •
                Main images must have a pure white background, must be a photo
                (not a drawing), and must not contain excluded accessories.
              </li>
              <li>
                JPEG is the preferred image format, but you also may use TIFF
                and GIF files.
              </li>
            </ul>
          }
          type="warning"
          closable
        />
        <br />
        <Row>
          <Col className="col-12">
            <h5>
              <Tooltip placement="top" title={imgImp1}>
                Product Cover Image&nbsp;
                <FaStarOfLife color="red" size={8} />
              </Tooltip>
            </h5>
          </Col>
          <Col sm="3" className="">
            <ImagePicker
              size={"lagre"}
              fileURL={coverImg?.url?.url ?? coverImg?.url ?? ""}
              remove={() => {
                setCoverImg({});
              }}
              onChange={(value: any) => {
                setCoverImg(value);
              }}
            />
          </Col>
          <hr />
          <Col className="col-12">
            <h5>
              <Tooltip placement="top" title={imgImp2}>
                Product Images{" "}
                {`(${props?.product?.productImages?.length ?? 0})`}&nbsp;
                <FaStarOfLife size={8} color="red" />
              </Tooltip>
            </h5>
          </Col>
          {data?.map((item: any, index: number) => {
            return (
              <Col sm={3}>
                <ImagePicker
                  size={"lagre"}
                  fileURL={item?.url?.Location ?? item?.url}
                  remove={() => removeNewImage(index)}
                  onChange={(value: any) => updateImage(value, index)}
                />
              </Col>
            );
          })}
          <Col sm={3}>
            <div
              className="AddProducts-newImagBox"
              onClick={() => CreateNewImage()}
            >
              <IoAddCircleOutline size={40} />
              <div>Add New</div>
            </div>
          </Col>
        </Row>
      </div>

      <br />
      <Row>
        <Col sm={6}></Col>
        <Col sm={2}>
          <Button size="large" block onClick={() => props?.onBack()}>
            Back
          </Button>
        </Col>
        <Col sm={4}>
          <Button
            size="large"
            block
            type="primary"
            htmlType="submit"
            onClick={() => submit()}
          >
            Continue
          </Button>
        </Col>
      </Row>
    </div>
  );
}
export default Images;
